/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsAuthenticatedStatus } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const useIsAuthRedirect = () => {
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const [isRedirectEnabled, setIsRedirectEnabled] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.sessionStorage) {
            const isAuthCallbackEnabled = sessionStorage.getItem('isAuthCallbackEnabled');
            if (isAuthenticated && isAuthCallbackEnabled === 'true' && !isRedirectEnabled) {
                setIsRedirectEnabled(true);
            }
        }
    }, [isAuthenticated]);

    return isRedirectEnabled;
};

export default useIsAuthRedirect;
